import { createVisitPrescriptionSchedule } from '../calendarVisitSchedule.schema';

/**
 * Normalizes an object of prescriptions grouped by padVisitId.
 * @param {Object} visitPrescriptionScheduleObject - The input object where keys are IDs and values are schedule data.
 */
export const normalizeVisitPrescriptionScheduleCooperative = visitPrescriptionSchedule => {
  const byPadVisitId = {};

  const id = visitPrescriptionSchedule.padVisitId;
  if (id) {
    byPadVisitId[id] = createVisitPrescriptionSchedule(visitPrescriptionSchedule);
  }

  return {
    ids: Object.keys(byPadVisitId).map(Number),
    byPadVisitId
  };
};
